import type { Box } from 'features/knowledgeDocumentViewer/components/viewer/shared/types'
import { ActionMode } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { DocumentViewerAssetType } from 'features/knowledgeDocumentViewer/types/ocrViewer'
import { useCallback } from 'react'

export const useBoxStyles = (
  hoverId: string | null,
  highlightedBoxIds: string[],
  actionMode: ActionMode
) => {
  const getFillOpacity = (isHovered: boolean) => (isHovered ? 0.4 : 0.2)

  const getStrokeOpacity = (isHovered: boolean) => (isHovered ? 1 : 0)

  const strokeFor = useCallback(
    (b: Box): string => {
      const isHovered = b.id === hoverId
      if (highlightedBoxIds.includes(b.id)) {
        if (actionMode === ActionMode.Assign) {
          return `rgba(52,211,153,${getStrokeOpacity(isHovered)})` // emerald-400
        }
        if (actionMode === ActionMode.Remove) {
          return `rgba(203,213,225,${getStrokeOpacity(isHovered)})` // slate-300
        }
        if (
          actionMode === ActionMode.Group ||
          actionMode === ActionMode.Split ||
          actionMode === ActionMode.Info ||
          actionMode === ActionMode.Link
        ) {
          return `rgba(168,85,247,${getStrokeOpacity(isHovered)})` // purple-500
        }
      }
      if (b.confirmed) {
        if (b.type === DocumentViewerAssetType.OFF_PAGE_CONNECTOR) {
          return `rgba(96,165,250,${getStrokeOpacity(isHovered)})` // blue-400
        } else {
          return `rgba(52,211,153,${getStrokeOpacity(isHovered)})` // emerald-400
        }
      }
      return `rgba(203,213,225,${getStrokeOpacity(isHovered)})` // slate-300
    },
    [hoverId, highlightedBoxIds, actionMode]
  )

  const fillFor = useCallback(
    (b: Box): string => {
      const isHovered = b.id === hoverId
      if (highlightedBoxIds.includes(b.id)) {
        if (actionMode === ActionMode.Assign) {
          return `rgba(52,211,153,${getFillOpacity(isHovered)})` // emerald-400
        }
        if (actionMode === ActionMode.Remove) {
          return `rgba(203,213,225,${getFillOpacity(isHovered)})` // slate-300
        }
        if (
          actionMode === ActionMode.Group ||
          actionMode === ActionMode.Split ||
          actionMode === ActionMode.Info ||
          actionMode === ActionMode.Link
        ) {
          return `rgba(168,85,247,${getFillOpacity(isHovered)})` // purple-500
        }
      }
      if (b.confirmed) {
        if (b.type === DocumentViewerAssetType.OFF_PAGE_CONNECTOR) {
          return `rgba(96,165,250,${getFillOpacity(isHovered)})` // blue-400
        } else {
          return `rgba(52,211,153,${getFillOpacity(isHovered)})` // emerald-400
        }
      }
      return `rgba(203,213,225,${getFillOpacity(isHovered)})` // slate-300
    },
    [hoverId, highlightedBoxIds, actionMode]
  )

  return { strokeFor, fillFor }
}
